import styled, { css } from 'styled-components'

import {
  color,
  radius,
  space,
  SpaceProps,
  spacing,
  typography,
} from '../../themes'

export type TextPosition = 'top' | 'center' | 'bottom'

interface ContainerProps extends SpaceProps {
  textPosition: TextPosition
  backgroundImg?: string
  backgroundSize?: number
  boxHeight?: number
}

const baseStyles = css`
  ${typography('caption1')};
  ${space};
  display: inline-flex;
  width: 100%;
  justify-content: center;
  padding: ${spacing(4, 4, 4)};
  border: dashed 1px ${color('gray.02')};
  border-radius: ${radius('md')};
  color: ${color('gray.02')};
`

export const Container = styled.span<ContainerProps>`
  ${baseStyles}

  align-items: ${({ textPosition }) =>
    textPosition === 'top'
      ? 'flex-start'
      : textPosition === 'bottom'
      ? 'flex-end'
      : 'center'};

  height: ${({ boxHeight }) => (boxHeight ? `${boxHeight}px` : 'auto')};
  min-height: 86px;

  ${({ backgroundImg, backgroundSize }) =>
    backgroundImg &&
    css`
      background-image: url('${backgroundImg}');
      background-repeat: no-repeat;
      background-position: center top;
      background-size: ${backgroundSize ?? 110}px;
    `}
`
